import useEntity from "../../hooks/useProviderUser";
import ProviderUserDetail from "../../components/providerUser/ProviderUserDetail/ProviderUserDetail";
import ProviderUserScoped from "../../components/providerUser/ProviderUserDetail/ProviderUserScoped";
import ProviderUserTabs from "../../components/providerUser/ProviderUserDetail/ProviderUserTabs";
import { useGetProviderUserQuery } from "../../apis/ProviderUser.api";
import { PrimaryProviderUser } from "../../types/models/ProviderUser";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ProviderUserDetailPage = () => {

    useTitle(t`Details Provider User`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { providerUserId: id } = useParams();

    const { data, refetch } = useGetProviderUserQuery(PrimaryProviderUser.fromPath(id))
    const { deleteProviderUser } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteProviderUser(data, '..')
    }, [data, deleteProviderUser])

    if (id === 'scoped') {
        return (<ProviderUserScoped/>)
    }

    return (
        <Box data-testid="ProviderUser-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ProviderUserDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ProviderUsers/update/view'
        ) ||
session.hasPermission(
            data.providerUserScopeGroupId,
            'applications/timber/entities/ProviderUsers/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="ProviderUser-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ProviderUsers/delete/view'
        ) ||
session.hasPermission(
            data.providerUserScopeGroupId,
            'applications/timber/entities/ProviderUsers/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="ProviderUser-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ProviderUserTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ProviderUserDetailPage;
